import React, { useEffect } from 'react';
import GridItem from 'components/Grid/GridItem';
import { translate } from 'components/Translation';
import InfoCard from 'components/Info/InfoCard';

interface IInformationCardProps {
	requestInfo: any;
	requestType?: string;
	amount?: number | null;
}

const InformationCard = ({ requestInfo, requestType, amount }: IInformationCardProps) => {
	return (
		<GridItem xs={12} md={12} style={{ paddingBottom: '12px' }}>
			<InfoCard
				elements={
					requestType && requestType === 'TARIFF_CHANGE'
						? TariffChangeInfoCardElements(requestInfo, amount)
						: requestType && (requestType === 'SIM_ACTIVATE' || requestType === 'SIM_REPLACE')
						? SimAcceptInfoCardElements(requestInfo, amount)
						: [
								{
									title: translate('service.requests.requestInfo'),
									value: JSON.stringify(requestInfo),
								},
						  ]
				}
			/>
		</GridItem>
	);
};

const TariffChangeInfoCardElements = (requestInfo: any, amount: number | null | undefined) => {
	return [
		{
			title: translate('service.requests.planToAdd'),
			value: requestInfo.productsToAdd[0].name,
		},
		{
			title: translate('total.amount'),
			value: amount ? translate('price', amount) : '',
		},
		{
			title: translate('service.requests.planToDelete'),
			value: requestInfo.productsToDelete[0].name,
		},
		{
			title: translate('service.requests.commitment.period'),
			value: requestInfo.productsToAdd[1].name,
		},
	];
};

const SimAcceptInfoCardElements = (requestInfo: any, amount: number | null | undefined) => {
	return [
		{
			title: translate('service.requests.sim.accept.msisdn'),
			value: requestInfo?.msisdn,
		},
		{
			title: translate('total.amount'),
			value: amount ? translate('price', amount) : '',
		},
		!!requestInfo?.serialNumber && {
			title: translate('serial.number'),
			value: requestInfo?.serialNumber,
		},
		{
			title: translate('service.requests.sim.context'),
			value: requestInfo?.context,
		},
	].filter(Boolean) as types.users.IPermission[];
};

export default InformationCard;
